module.exports = {
      id: "french-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#french-usage",
      toString: function () {
        return this.url;
      }
    }